import { useMutation, useQueryClient } from '@tanstack/react-query';
import { USER_PROFILES_IMAGE_KEY } from '../../utils/constants/queryKeys';
import { uploadUserProfileImage } from '../services/fn-api/User';

export const useUploadUserProfileImage = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, File>({
    mutationFn: async (file: File) => {
      const formData = new FormData();
      formData.append('file', file);

      return uploadUserProfileImage(formData);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [USER_PROFILES_IMAGE_KEY] });
    },
  });
};
